var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPermission('organisation:manage'))?_c('div',{staticClass:"org-details"},[_c('v-row',[_c('v-col',{attrs:{"cols":"8"}},[_c('OrganisationEdit',{attrs:{"organisation":_vm.activeOrganisation[0]}})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }